var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKeysightLogoShorter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2022_logo_-_lt_theme",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212 54.7",
    style: {
      enableBackground: "new 0 0 212 54.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E90029;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KS-Horizontal-Logo-2021_RGB"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.6,38c-0.3,0-1-0.4-1.5-2.2c-0.8-3-1.2-5.5-2.4-5.5s-1.9,2.5-2.7,5.5c-0.5,1.8-0.9,2.2-1.7,2.2 s-1.5-0.3-2.6-4.9c-1-4-1.6-11.2-4.9-11.2s-4.2,9.4-4.6,11.2c-0.5,2.2-1.8,4.9-3.4,4.9s-2.4-1.8-2.9-3.8c-0.7-3-1.6-7.4-3.7-7.4 s-2.8,3.6-3.8,7.6c-0.6,2.3-1.4,3.6-3,3.6H17c0.9,0.4,1.5,1.3,1.6,2.3c0.5,3.3,0.9,5.5,2.1,5.5s1.6-1.7,2.3-4.5 c0.5-2.2,1.3-3.2,2.3-3.2c1.5,0,2.1,1.8,2.9,5.1c1.6,6.7,1.9,10,4.5,10s2.9-3.2,4.6-10c0.7-2.9,2.1-5.1,3.7-5.1s2.8,2.1,3.3,3.8 c1.3,3.7,1.8,5.1,3.2,5.1s2.2-1.7,3.4-5.7c0.8-2.5,0.9-3.2,3.2-3.2H57.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.4,47 67.8,37.1 67.8,47 64.4,47 64.4,26.7 67.8,26.7 67.8,35.5 75.8,26.7 80.2,26.7 71.3,36.3 80.9,47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.6,26.7 94.6,29.9 85.9,29.9 85.9,34.7 93.6,34.7 93.6,38 85.9,38 85.9,43.8 94.6,43.8 94.6,47 82.6,47 82.6,26.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.9,26.7 105.1,34.8 110.1,26.7 114.1,26.7 106.7,38.2 106.7,47 103.3,47 103.3,38.2 95.8,26.7  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1,40.5h3.3c0,2.2,1.8,3.7,4.2,3.7s3.9-1.2,3.9-2.9c0-4.6-11.2-1.6-11.2-9.1c0-3.4,2.9-5.8,6.9-5.8 c4.7,0,7.1,3,7.1,6.4h-3.5c-0.1-1.8-1.5-3.2-3.7-3.2c-2.1,0-3.4,1-3.4,2.5c0,4.2,11.2,1.3,11.2,9.1c0,3.5-3.1,6.1-7.3,6.1 S114.1,44.4,114.1,40.5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131,
    y: 26.7,
    width: 3.4,
    height: 20.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.5,37.5c0.1,5.3-4,9.6-9.3,9.8c-0.2,0-0.4,0-0.6,0c-5.6,0.1-10.2-4.5-10.3-10.1c0-0.1,0-0.3,0-0.4 c-0.2-5.6,4.2-10.3,9.8-10.4c0.1,0,0.3,0,0.4,0c4.6,0,8.7,3.1,9.4,6.7h-3.8c-0.8-2-3.2-3.4-5.6-3.4c-3.7,0-6.8,3.1-6.7,6.8 c0,0.1,0,0.2,0,0.3c-0.2,3.8,2.8,7,6.6,7.2c0.1,0,0.3,0,0.4,0c3,0.1,5.7-2.1,6.2-5.1h-6.4v-3.3h9.7 C156.5,36.2,156.5,36.9,156.5,37.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "175.2,26.7 175.2,47 171.8,47 171.8,38.1 161.9,38.1 161.9,47 158.6,47 158.6,26.7 161.9,26.7 161.9,34.8 171.8,34.8 171.8,26.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193,29.9 186.8,29.9 186.8,47 183.4,47 183.4,29.9 177.1,29.9 177.1,26.7 193,26.7  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeysightLogoShorter);
export default __webpack_public_path__ + "static/media/keysight-logo-shorter.f5697965b2a8fd760c111de9ae9f9ece.svg";
export { ForwardRef as ReactComponent };